import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL + '/api';

const BitPayment = () => {
  const [searchParams] = useSearchParams();
  const amount = searchParams.get('amount') || '0';
  const name = searchParams.get('name') || '';
  const orderNum = searchParams.get('order') || '';
  const [error, setError] = useState('');

  useEffect(() => {
    let mounted = true;
    const fetchAndRedirect = async () => {
      try {
        const resp = await axios.post(`${API}/payments/bit/create`, {
          amount: parseFloat(amount),
          order_id: orderNum,
          customer_name: name,
        });
        if (resp.data.bit_url && mounted) {
          window.location.href = resp.data.bit_url;
        } else if (mounted) {
          setError('לא ניתן ליצור לינק ביט כרגע');
        }
      } catch (e) {
        // Wait before showing error - the redirect might still be processing
        if (mounted) {
          setTimeout(() => {
            if (mounted) setError(e.response?.data?.detail || 'שגיאה ביצירת תשלום');
          }, 5000);
        }
      }
    };
    fetchAndRedirect();
    return () => { mounted = false; };
  }, [amount, orderNum, name]);

  if (error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center p-4" dir="rtl">
        <div className="text-center">
          <p className="text-red-500 font-bold mb-2">{error}</p>
          <p className="text-stone-400 text-sm">נסו שוב מאוחר יותר</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white flex items-center justify-center" dir="rtl">
      <div className="text-center">
        <img src="https://customer-assets.emergentagent.com/job_d56f6086-1f6c-43f9-a07d-5d56a502df97/artifacts/6m20ykko_image.png" alt="bit" className="w-16 h-16 rounded-2xl mx-auto mb-4" />
        <div className="w-8 h-8 border-3 border-[#00657C] border-t-transparent rounded-full animate-spin mx-auto mb-3" />
        <p className="text-stone-500">מעביר לתשלום בביט...</p>
        <p className="text-center text-[11px] text-stone-500 mt-4 px-4 leading-relaxed max-w-xs mx-auto" style={{ fontFamily: 'Heebo, sans-serif' }} data-testid="terms-disclaimer-bit">
          בלחיצה על המשך תשלום, קראתי והנני מאשר את{' '}
          <a href="/terms" target="_blank" rel="noopener noreferrer" className="text-[#D97706] hover:underline font-bold">
            תנאי השימוש ותקנון האתר
          </a>
        </p>
      </div>
    </div>
  );
};

export default BitPayment;
